import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
    <header className="bg-[#0a1a3d] py-5">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <div className="w-8 h-8 bg-[#0E47B0] rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-sm">L</span>
          </div>
          <span className="text-white font-bold text-lg">Lex Recupero™</span>
        </Link>
        <Link to="/" className="text-white/60 hover:text-white text-sm no-underline transition-colors">&larr; Torna alla home</Link>
      </div>
    </header>

    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-[32px] font-bold text-[#1a1a2e] mb-4">Informativa sulla Privacy</h1>
      <p className="text-sm text-[#4a4a6a] mb-2">Titolare del trattamento: Lex Recupero™ Studio Legale</p>
      <p className="text-sm text-[#4a4a6a] mb-2">Email: info@lexrecupero.it</p>
      <p className="text-sm text-[#4a4a6a] mb-6">Ultimo aggiornamento: Aprile 2026</p>

      <div className="space-y-6 text-[15px] text-[#4a4a6a] leading-[1.8]">
        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">1. Titolare del trattamento</h2>
          <p>Il titolare del trattamento dei dati personali raccolti attraverso questo sito è Lex Recupero™ Studio Legale, con sede in Italia. Per qualsiasi questione relativa al trattamento dei tuoi dati personali, puoi contattarci all'indirizzo email: info@lexrecupero.it.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">2. Dati personali raccolti e modalità di raccolta</h2>
          <p>Raccogliamo i seguenti dati personali attraverso il modulo di contatto presente sul sito:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li><strong>Nome e cognome</strong> &mdash; per identificare il richiedente</li>
            <li><strong>Indirizzo email</strong> &mdash; per il ricontatto in merito alla richiesta</li>
            <li><strong>Numero di telefono</strong> (facoltativo) &mdash; per eventuale contatto telefonico</li>
            <li><strong>Data e ora della richiesta</strong> &mdash; per la gestione interna delle richieste</li>
          </ul>
          <p className="mt-3">I dati vengono raccolti mediante la compilazione volontaria del modulo presente sulla pagina. La fornitura dei dati contrassegnati come obbligatori (nome, cognome, email) è necessaria per poter rispondere alla richiesta. Il numero di telefono è facoltativo.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">3. Finalità e base giuridica del trattamento</h2>
          <p>I tuoi dati personali vengono trattati per le seguenti finalità:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li><strong>Gestione delle richieste di informazioni legali preliminari</strong> &mdash; base giuridica: consenso espresso dell'interessato (art. 6, par. 1, lett. a GDPR)</li>
            <li><strong>Contatto per la valutazione preliminare gratuita</strong> &mdash; base giuridica: adempimento di misure precontrattuali su richiesta dell'interessato (art. 6, par. 1, lett. b GDPR)</li>
            <li><strong>Miglioramento del servizio e della qualità della risposta</strong> &mdash; base giuridica: legittimo interesse del titolare (art. 6, par. 1, lett. f GDPR)</li>
          </ul>
          <p className="mt-3">I dati <strong>non vengono</strong> utilizzati per finalità di marketing diretto, né per la profilazione automatizzata ai fini pubblicitari.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">4. Condivisione e comunicazione dei dati</h2>
          <p>I tuoi dati personali <strong>non vengono venduti</strong> né condivisi con terze parti a fini commerciali. Possono essere comunicati a:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Collaboratori interni allo studio, per la gestione della tua richiesta</li>
            <li>Fornitori tecnici di servizi cloud e hosting, nella misura strettamente necessaria all'erogazione del servizio (in qualità di responsabili del trattamento ai sensi dell'art. 28 GDPR)</li>
          </ul>
          <p className="mt-3">Nessun trasferimento di dati verso paesi extra-UE privi di adeguate garanzie di protezione.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">5. Periodo di conservazione</h2>
          <p>I dati personali vengono conservati per il tempo necessario al perseguimento delle finalità per cui sono stati raccolti, e comunque:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Per i dati relativi a richieste di informazioni: non oltre 24 mesi dalla data di ricezione della richiesta, salvo diversa disposizione di legge</li>
            <li>Per i dati relativi a rapporti professionali avviati: secondo quanto previsto dalle norme deontologiche e dalla normativa sull'archivio professionale</li>
          </ul>
          <p className="mt-3">Trascorso il periodo di conservazione, i dati saranno cancellati o anonimizzati.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">6. I tuoi diritti (GDPR)</h2>
          <p>Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003, hai il diritto di:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li><strong>Accesso</strong>: ottenere conferma del trattamento e accedere ai tuoi dati</li>
            <li><strong>Rettifica</strong>: richiedere la correzione di dati inesatti o incompleti</li>
            <li><strong>Cancellazione</strong> ("diritto all'oblio"): richiedere la cancellazione dei tuoi dati</li>
            <li><strong>Limitazione</strong>: richiedere la limitazione del trattamento in determinati casi</li>
            <li><strong>Portabilità</strong>: ricevere i tuoi dati in formato strutturato e leggibile</li>
            <li><strong>Opposizione</strong>: opporti al trattamento per motivi legittimi</li>
            <li><strong>Revoca del consenso</strong>: revocare in qualsiasi momento il consenso prestato</li>
          </ul>
          <p className="mt-3">Per esercitare questi diritti, scrivi a: <a href="mailto:info@lexrecupero.it" className="text-[#0E47B0] hover:underline">info@lexrecupero.it</a>. Risponderemo entro 30 giorni. Hai inoltre il diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">7. Cookie e tecnologie di tracciamento</h2>
          <p>Il sito utilizza cookie tecnici necessari al funzionamento e cookie analitici anonimi per il miglioramento del servizio. Per i dettagli, consulta la nostra <Link to="/cookie-policy" className="text-[#0E47B0] hover:underline">Cookie Policy</Link>.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">8. Sicurezza dei dati</h2>
          <p>Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali da accesso non autorizzato, divulgazione, alterazione o distruzione, in conformità all'art. 32 GDPR.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">9. Contatti del titolare</h2>
          <p>Per qualsiasi questione relativa alla privacy o per esercitare i tuoi diritti:</p>
          <p className="mt-2"><strong>Email:</strong> <a href="mailto:info@lexrecupero.it" className="text-[#0E47B0] hover:underline">info@lexrecupero.it</a></p>
          <p className="mt-1"><strong>Titolare:</strong> Lex Recupero™ Studio Legale, Italia</p>
        </section>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;
